import { render, staticRenderFns } from "./StatisticsMod.vue?vue&type=template&id=0675842a&scoped=true"
import script from "./StatisticsMod.vue?vue&type=script&lang=ts"
export * from "./StatisticsMod.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsMod.vue?vue&type=style&index=0&id=0675842a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0675842a",
  null
  
)

export default component.exports